<div class="ot-list-tile" [ngClass]="{'ot-list-tile--is-detail': titleType === 'detail', 'ot-list-tile--is-simple': titleType === 'simple', 'ot-list-tile--is-complex': titleType === 'complex'}" [id]="id" style="max-height: 100%;" (keyup)="onKeyClose($event)">
  <div class="ot-list-tile__header" [id]="id + '-list-tile-header'" [ngClass]="{'ot-list-tile__header_hover': !isInsideModalDlg && viewLink && viewLinkClass === 'd-inline'}" (mouseover)="viewLinkClass='d-inline'" (mouseout)="viewLinkClass='d-none'" (focus)="viewLinkClass='d-inline'" (focusout)="viewLinkClass='d-none'" (keyup.enter)="goToViewLink()">
    @if (!showSearch) {
      <div class="ot-list-tile__title" i18n>
            {{title}}
        </div>
    }
    @if (filterProperties.length > 0) {
      @if (showSearch) {
        <div class="ot-list-tile__title ot-list-tile__title_search">
          <input class="ot-list-title__title_search_input" type="search" i18n-placeholder [placeholder]="placeholder" i18n-title [title]="placeholder" tabindex="0" [(ngModel)]="query" (ngModelChange)="filterList()">
        </div>
      }
      <button aria-label="icon" i18n-title title="search" class="ot-btn ot-btn--is-micro ot-btn--is-icon-btn ot-list-tile__icon_search otsc-list-tile-button" (click)="toggleSearchField()" [id]="id + '-list-tile-search-btn'">
        <div class="ot-icon ot-icon--is-16x16">
          <img src="./assets/icons/menu_search.svg" alt="search" i18n-alt>
        </div>
      </button>
    }
    @if (!isInsideModalDlg && viewLink) {
      <button aria-label="icon" [ngClass]="viewLinkClass" [title]="viewLinkDescription ? viewLinkDescription : 'View'" class="ot-btn ot-btn--is-micro d-none ot-btn--is-icon-btn ot-list-tile__icon_view ot-pr-0 ot-pl-0" (click)="goToViewLink()" >
        <div class="ot-icon ot-icon--is-24x24">
          <img src="./assets/icons/quick_link.svg" alt="viewLinkDescription ? viewLinkDescription : 'View'">
        </div>
      </button>
    }
    @if (isInsideModalDlg) {
      <button aria-label="icon" i18n-title title="close" class="ot-btn ot-btn--is-micro ot-btn--is-icon-btn ot-list-tile__icon_close otsc-list-tile-button" (click)="close()" [id]="id + '-list-tile-close-btn'">
        <div class="ot-icon ot-icon--is-16x16">
          <img src="./assets/icons/close.svg" alt="close" i18n-alt>
        </div>
      </button>
    }
  </div>
  @if (!isLoading) {
    <div class="ot-list-tile__body" [ngStyle]="{'height': contentHeight}">
      @if ((items && items.length > 0) || (!query && list && list.length > 0)) {
        <ng-content></ng-content>
      }
      @if ((items && items.length === 0) || (!query && list && list.length === 0)) {
        <div>
          <div class="otsc-no-items__icon"></div>
          <div class="otsc-no-items__text" i18n>
                There are no items to display.
            </div>
        </div>
      }
    </div>
  }
  @if (isLoading) {
    <div class="ot-list-tile__body">
      <div class="ot-level">
        <div class="ot-level__left">
          <div class="ot-level__item">
          </div>
        </div>
        <div class="ot-level__center">
          <div class="ot-level__item">
            <div class="ot-progress-container">
              <div id="ot-spinner-text" class="ot-progress ot-progress--is-spinner ot-progress--is-spinner-has-text">
                <div class="ot-progress__outer">
                  <div class="ot-progress__meter">
                  </div>
                </div>
                <div class="ot-progress__text" i18n>
                            Loading...
                        </div>
              </div>
            </div>
          </div>
        </div>
        <div class="ot-level__right">
          <div class="ot-level__item">
          </div>
        </div>
      </div>
    </div>
  }
</div>